<p-dialog
  [(visible)]="visible"
  [header]="'Grupos — ' + (utilizador?.nome ?? '')"
  [modal]="true"
  [style]="{ width: 'min(90vw, 460px)' }"
  [draggable]="false"
  [closable]="!processando"
  [closeOnEscape]="!processando"
  [dismissableMask]="!processando"
  (onHide)="fechar()"
>
  <p class="aviso">
    A API não permite listar os grupos a que este utilizador já pertence —
    escolhe o grupo e a acção pretendida.
  </p>

  <div class="skeleton-rows" *ngIf="carregandoGrupos">
    <p-skeleton height="38px"></p-skeleton>
  </div>

  <div class="error-state" *ngIf="!carregandoGrupos && erroGrupos">
    <i class="fas fa-triangle-exclamation"></i>
    <p>Não foi possível carregar a lista de grupos.</p>
  </div>

  <div class="form-group" *ngIf="!carregandoGrupos && !erroGrupos">
    <label for="grupoSelect">Grupo</label>
    <p-select
      inputId="grupoSelect"
      [options]="grupos"
      optionLabel="nome"
      optionValue="id"
      [(ngModel)]="grupoSelecionadoId"
      placeholder="Seleccione um grupo"
      styleClass="w-full"
      appendTo="body"
      [filter]="true"
      filterBy="nome"
      filterPlaceholder="Pesquisar..."
      [showClear]="true"
      [disabled]="processando"
    >
    </p-select>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer-actions">
    <button
      type="button"
      class="btn-web-secondary"
      [disabled]="processando"
      (click)="fechar()"
  >
      Fechar
    </button>
    
   <!--<button
      type="button"
      class="btn-danger"
      [disabled]="!grupoSelecionadoId || processando"
      (click)="confirmarRemover()"
    >
      <i
        [class]="
          acaoProcessando === 'remover'
            ? 'fas fa-spinner fa-spin'
            : 'fas fa-user-minus'
        "
      ></i>
      Remover do grupo
    </button> -->

    <button
      type="button"
      class="btn-web-primary"
      [disabled]="!grupoSelecionadoId || processando"
      (click)="adicionar()"
    >
      <i
        [class]="
          acaoProcessando === 'adicionar'
            ? 'fas fa-spinner fa-spin'
            : 'fas fa-user-plus'
        "
      ></i>
      Adicionar ao grupo
    </button>

    </div>
  </ng-template>
</p-dialog>
